import { Component, OnInit, Input, DoCheck, Output, EventEmitter } from '@angular/core';
import { FormDataService } from '../services/form-data.service';

@Component({
  selector: 'app-payment-form',
  templateUrl: './payment-form.component.html',
  styleUrls: ['./payment-form.component.scss'],
  standalone: false
})
export class PaymentFormComponent implements OnInit, DoCheck {
  @Input('getJSONWithPrem') recievedJSONWithPrem: any;
  @Input('getCurrency') recievedCurrency: string;
  @Input('getAmoutOfMoney') recievedAmoutOfMoney: any;
  @Input('getSelectedPaymentType') recievedSelectedPaymentType: number;
  @Input('getYears') recievedYears: number;
  @Input('getInitManPrem') initManPrem: number;
  @Output('calculateAgain') sendToForm = new EventEmitter<boolean>();
  @Output('changePackage') exportFromDetails = new EventEmitter<any>();
  // @Input('payment') recievedPayment: any; // tova go maham

  private payment: any;
  public currency: string = "";
  private selectedPaymentType: number;
  private moneyByDeath: number;
  private moneyByCrill: number;
  public isPaymentFormButtonClicked: boolean = false;
  private isDeathByAccidentIncluded: boolean = false;
  private isLongTermLossOfEmploymentByAccidentIncluded: boolean = false;
  private isLongTermLossOfEmploymentByDiseaseIncluded: boolean = false;
  private isTemporraryLossOfEmploymentByAccidentIncluded: boolean = false;
  private isTemporraryLossOfEmploymentByDiseaseIncluded: boolean = false;
  private isStayAtHospitalByAccidentIncluded: boolean = false;
  private isStayAtHospitalByDiseaseIncluded: boolean = false;
  private isExpenditureForMedicinesByAccidentIncluded: boolean = false;
  private isExpenditureForMedicinesByDiseaseIncluded: boolean = false;
  private isCrillIncluded: boolean = false;
  private isSecondMedicalOpinionIncluded: boolean = false;
  public state: boolean=false;
  public removePackages: boolean= false;

  constructor(private data: FormDataService) { }

  ngOnInit() {
    this.data.currentState.subscribe(state => this.state = state);
    this.data.currentRemovePackages.subscribe(state => this.state = state);
  }

  ngDoCheck() {
    this.payment = this.recievedJSONWithPrem.manPrem;
    this.currency = this.recievedCurrency;
    this.moneyByDeath = this.recievedAmoutOfMoney * 2;
    this.moneyByCrill = this.recievedAmoutOfMoney / 2;
    // this.selectedPaymentType = this.recievedSelectedPaymentType * 1;
    this.showWhatIsChoosenOnTheScreen();
  }

  expandPaymentForm() {
    this.isPaymentFormButtonClicked = !this.isPaymentFormButtonClicked;
  }

  // check which package is choosen and which options and show them on the screen
  showWhatIsChoosenOnTheScreen() {
    if (this.recievedJSONWithPrem.selectedPackage === "protectLight") {
      this.isDeathByAccidentIncluded = true;

      this.isLongTermLossOfEmploymentByAccidentIncluded = true;

      this.isTemporraryLossOfEmploymentByAccidentIncluded = false;
      this.isStayAtHospitalByAccidentIncluded = false;
      this.isExpenditureForMedicinesByAccidentIncluded = false;

      this.isLongTermLossOfEmploymentByDiseaseIncluded = false;
      this.isTemporraryLossOfEmploymentByDiseaseIncluded = false;
      this.isStayAtHospitalByDiseaseIncluded = false;
      this.isExpenditureForMedicinesByDiseaseIncluded = false;

      this.checkIfCriilAndSecondMedicalOpinianAreIncluded();
    }
    else if (this.recievedJSONWithPrem.selectedPackage === "protectPlus") {
      this.isDeathByAccidentIncluded = true;

      this.isLongTermLossOfEmploymentByAccidentIncluded = true;
      this.isTemporraryLossOfEmploymentByAccidentIncluded = true;
      this.isStayAtHospitalByAccidentIncluded = true;
      this.isExpenditureForMedicinesByAccidentIncluded = true;

      this.isLongTermLossOfEmploymentByDiseaseIncluded = false;
      this.isTemporraryLossOfEmploymentByDiseaseIncluded = false;
      this.isStayAtHospitalByDiseaseIncluded = false;
      this.isExpenditureForMedicinesByDiseaseIncluded = false;

      this.checkIfCriilAndSecondMedicalOpinianAreIncluded();
    }
    else if (this.recievedJSONWithPrem.selectedPackage === "protectPremium") {
      this.isDeathByAccidentIncluded = true;

      this.isLongTermLossOfEmploymentByDiseaseIncluded = true;
      this.isTemporraryLossOfEmploymentByDiseaseIncluded = true;
      this.isStayAtHospitalByDiseaseIncluded = true;
      this.isExpenditureForMedicinesByDiseaseIncluded = true;

      this.isLongTermLossOfEmploymentByAccidentIncluded = false;
      this.isTemporraryLossOfEmploymentByAccidentIncluded = false;
      this.isStayAtHospitalByAccidentIncluded = false;
      this.isExpenditureForMedicinesByAccidentIncluded = false;

      this.checkIfCriilAndSecondMedicalOpinianAreIncluded();
    }
    else if (this.recievedJSONWithPrem.selectedPackage === "custom") {
      this.showWhatIsChoosenOnTheScreenByCustom();
    }
    else {
      this.showWhatIsChoosenOnTheScreenByCustom();
    }
  }

  showWhatIsChoosenOnTheScreenByCustom() {
    if (this.recievedJSONWithPrem.death === "Y") {
      this.isDeathByAccidentIncluded = true;
    }
    else {
      this.isDeathByAccidentIncluded = false;
    }

    if (this.recievedJSONWithPrem.longTermLossOfEmployment === 1) {
      this.isLongTermLossOfEmploymentByAccidentIncluded = true;
      this.isLongTermLossOfEmploymentByDiseaseIncluded = false;
    }
    else if (this.recievedJSONWithPrem.longTermLossOfEmployment === 2) {
      this.isLongTermLossOfEmploymentByDiseaseIncluded = true;
      this.isLongTermLossOfEmploymentByAccidentIncluded = false;
    }
    else {
      this.isLongTermLossOfEmploymentByAccidentIncluded = false;
      this.isLongTermLossOfEmploymentByDiseaseIncluded = false;
    }

    if (this.recievedJSONWithPrem.temporraryLossOfEmployment === 1) {
      this.isTemporraryLossOfEmploymentByAccidentIncluded = true;
      this.isTemporraryLossOfEmploymentByDiseaseIncluded = false;
    }
    else if (this.recievedJSONWithPrem.temporraryLossOfEmployment === 2) {
      this.isTemporraryLossOfEmploymentByDiseaseIncluded = true;
      this.isTemporraryLossOfEmploymentByAccidentIncluded = false;
    }
    else {
      this.isTemporraryLossOfEmploymentByAccidentIncluded = false;
      this.isTemporraryLossOfEmploymentByDiseaseIncluded = false;
    }

    if (this.recievedJSONWithPrem.stayAtHospital === 1) {
      this.isStayAtHospitalByAccidentIncluded = true;
      this.isStayAtHospitalByDiseaseIncluded = false;
    }
    else if (this.recievedJSONWithPrem.stayAtHospital === 2) {
      this.isStayAtHospitalByDiseaseIncluded = true;
      this.isStayAtHospitalByAccidentIncluded = false;
    }
    else {
      this.isStayAtHospitalByAccidentIncluded = false;
      this.isStayAtHospitalByDiseaseIncluded = false;
    }

    if (this.recievedJSONWithPrem.expenditureForMedicines === 1) {
      this.isExpenditureForMedicinesByAccidentIncluded = true;
      this.isExpenditureForMedicinesByDiseaseIncluded = false;
    }
    else if (this.recievedJSONWithPrem.expenditureForMedicines === 2) {
      this.isExpenditureForMedicinesByDiseaseIncluded = true;
      this.isExpenditureForMedicinesByAccidentIncluded = false;
    }
    else {
      this.isExpenditureForMedicinesByAccidentIncluded = false;
      this.isExpenditureForMedicinesByDiseaseIncluded = false;
    }
    this.checkIfCriilAndSecondMedicalOpinianAreIncluded();
  }

  checkIfCriilAndSecondMedicalOpinianAreIncluded() {
    if (this.recievedJSONWithPrem.crill === "Y") {
      this.isCrillIncluded = true;
    }
    else {
      this.isCrillIncluded = false;
    }

    if (this.recievedJSONWithPrem.secondMedOp === "Y") {
      this.isSecondMedicalOpinionIncluded = true;
    }
    else {
      this.isSecondMedicalOpinionIncluded = false;
    }
  }

  changeChosenPackage() {
    this.exportFromDetails.emit(' ');
    this.data.changePackageState(true);
  }

  calculateAgain(){
    this.sendToForm.emit(true);
  }

}
